import { useState } from "react";
import { Link } from "react-router-dom";
import { hasSeenTutorial, markTutorialSeen } from "../lib/tutorial";

/**
 * A one-time nudge towards the guided tour (finding #28).
 *
 * Shown until somebody either takes the tour or dismisses it, and never again after that -- a banner
 * that reappears every visit stops being a suggestion and becomes furniture people learn to ignore.
 *
 * Deliberately a strip on the page rather than a modal over it: a coach who already knows what they are
 * doing should not have to close a dialog before reaching their roster.
 */
export function TourPrompt() {
  const [dismissed, setDismissed] = useState(() => hasSeenTutorial());
  if (dismissed) return null;

  return (
    <div className="tour-prompt">
      <span>New here? There&rsquo;s a short guide to how this all works.</span>
      <Link className="link-button" to="/help">
        Show me
      </Link>
      <button
        type="button"
        className="chip"
        onClick={() => {
          markTutorialSeen();
          setDismissed(true);
        }}
      >
        No thanks
      </button>
    </div>
  );
}
